import { Helmet } from "react-helmet";
import { useLocation } from "react-router";
import { siteTitle } from "../../constants";

export const PageHelmet = () => {
  const location = useLocation();
  return (
    <Helmet>
      <title>
        {(() => {
          switch (location.pathname) {
            case "/profil":
              return "Profil | ";
            case "/palyazatok":
              return "Pályázatok | ";
            case "/jelentes":
              return "Jelentés | ";
            case "/bejelentkezes":
              return "Bejelentkezés | ";
            case "/regisztracio":
              return "Regisztráció | ";
            case "/palyazat":
              return "Pályázat | ";
            case "/kapcsolat":
              return "Kapcsolat | ";
            case "/dokumentumok":
              return "Dokumentumok | ";
            default:
              return "Főoldal | ";
          }
        })()}
        {siteTitle}
      </title>
      <meta name="description" content={siteTitle} />
      {/* A favicon linkeket a public/index.html head-scriptje teszi be, még az
          első festés előtt — innen kivéve, mert a Helmet csak hozzáadta őket a
          statikus Breki linkek mellé, nem cserélte le. */}
    </Helmet>
  );
};
